import React from'react';
import style from "./BotaoNovoAtualizado.module.css"
import { Link } from "react-router-dom";

function BotaoNovoAtualizado({link}) {

    return (
        <Link onClick={link} className={style.botao_novo}>
            + Novo
        </Link>
    );
}
export default BotaoNovoAtualizado;